import { Component, OnInit, Input } from '@angular/core';
import { Option } from 'src/app/models/option';
import { UiUtils } from 'src/app/util/ui-utils';
import { TranslateService } from '@ngx-translate/core';
import {OptionGroupService} from "../../services/option-group.service";

@Component({
  selector: 'app-option-add-edit',
  templateUrl: './option-add-edit.component.html',
  styleUrls: ['./option-add-edit.component.scss'],
})
export class OptionAddEditComponent implements OnInit {

  @Input() option: Option;
  mode: 'adding'|'editing' = 'editing';

  constructor(
    private optionService: OptionGroupService,
    private uiUtils: UiUtils,
    private translateService: TranslateService
  ) { }

  ngOnInit() {
    if (!this.option) {
      this.resetOption()
      this.mode = 'adding';
    }
  }

  addOption() {
    const formValidation = this.getFormValidation();
    if (!formValidation.isValid) return this.uiUtils.showConfirmAlert(this.translateService.instant('generic.invalidField'), formValidation.errorMsg, this.translateService.instant('generic.accept'));

    if (!this.option.price) this.option.price = new Option().price;

    // this.optionService.addOptionGroup(this.option).addOption({...this.option}).then(option => this.resetOption());
  }

  resetOption() {
    this.option = new Option();
    // this.option.restaurantId = EatmaticStoreService.getRestaurant().key;
    this.option.price = undefined;
  }

  private getFormValidation() {
    let isValid = true;
    let errorMsg: string;

    if (!this.option.name ) errorMsg = this.translateService.instant('component.option_add_edit.message.nameRequired');
    if (this.option.price && this.option.price <= 0) errorMsg = this.translateService.instant('component.option_add_edit.message.priceValue');

    isValid = errorMsg ? false : true;
    return {isValid, errorMsg};
  }

}
